import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Weekend, PhotoCamera } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import PhotoModal from './PhotoModal';
import { useModal } from 'hooks/useModal';
import { nombreEstadoMueble } from './estados';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 160 },
  { Header: 'Código', accessor: 'code', width: 130 },
  { Header: 'N° de serie', accessor: 'serial', width: 150 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Foto', accessor: 'photo', excelEnabled: false, width: 80 },
  { Header: 'Categoría', accessor: 'category', width: 160 },
  { Header: 'Estado', accessor: 'state', width: 130 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

/** Mantenimiento de muebles. El código puede quedar en blanco. */
export default WithApp(function Furniture(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [modelFoto, setOpenFoto] = useModal();
  const [notify, showNotify] = useToasty();
  const [furnitures, setFurnitures] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadFurnitures() {
    setDataLoading(true);
    let response = await wsGetAll('base/furniture');
    setDataLoading(false);
    if (response.success) setFurnitures(response.data);
  }

  useEffect(() => {
    loadFurnitures();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadFurnitures} />
      ) : undefined}
      {modelFoto.open ? (
        <PhotoModal
          model={modelFoto}
          setOpen={setOpenFoto}
          showNotify={showNotify}
          reload={loadFurnitures}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX}
              component={
                <CardIcon color="primary">
                  <Weekend style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Listado de muebles {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Muebles"
              defaultWidth={900}
              columns={columns}
              data={furnitures.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpenFoto(item)}
                        >
                          <PhotoCamera />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColor}
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CUSTOMER_INDEX}>
                        <ButtonDelete entity="base/furniture" id={item.id} reload={loadFurnitures} />
                      </AllowedGuard>
                    </div>
                  ),
                  //código y serie quedan vacíos hasta que el usuario los complete
                  code: item.code || '',
                  serial: item.serial_number || '',
                  description: item.description,
                  photo: item.file_url ? (
                    <a href={item.file_url} target="_blank" rel="noreferrer">
                      <img
                        src={item.file_url}
                        alt="Mueble"
                        style={{ width: 38, height: 38, objectFit: 'cover', borderRadius: 4 }}
                      />
                    </a>
                  ) : (
                    ''
                  ),
                  category: item.category?.description || '',
                  state: nombreEstadoMueble(item.state),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
